export const Learning = () => (
  <svg width="66" height="66">
    <g fill="none" fillRule="evenodd">
      <path
        d="M54.92 54.92c-12.106 12.107-31.734 12.107-43.84 0-12.107-12.106-12.107-31.734 0-43.84 12.106-12.106 31.734-12.106 43.84 0 12.107 12.106 12.107 31.734 0 43.84zM27 45l12-3M27 49l12-3M27 52l12-3M31 55l5-2"
        stroke="#FFF"
        strokeWidth="2.254"
        strokeLinecap="round"
      />
      <path
        d="M27.811 42c0-3.466-1.01-5.738-3.296-8.074-4.687-4.786-4.687-12.548 0-17.335A11.842 11.842 0 0 1 33 13M38.52 39c.462-1.906 1.423-3.455 2.965-5.033 4.687-4.796 4.687-12.573 0-17.37C39.142 14.2 36.072 13 33 13"
        stroke="#FFF"
        strokeWidth="2.254"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 20s-2.835 4.603-1.755 6.165c0 0 .604.835 1.377.835 0 0-.587-2.542.378-7"
        fill="#FFF"
      />
      <path
        d="M26 20s-2.835 4.603-1.755 6.165c0 0 .604.835 1.377.835 0 0-.587-2.542.378-7z"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
